import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  API_PATH,
  cancelCashFlow,
  createCashFlow,
  createUser,
  deleteUser,
  getActivities,
  getListCashFlow,
  getStatistic,
  getTranToday,
  listUser,
  profile,
  resetPassword
} from "../../services/auth";

const initialState = {
  list: [],
  current: null,
  profile: null,
  statistic: {},
  activities: [],
  activitiesMetaData: null,
  listTranDayHistory: [],
  listCashFlow: []
};

export const getListAccount = createAsyncThunk(
  `${API_PATH}/list-user`,
  async () => listUser()
);

export const getProfileUser = createAsyncThunk(`${API_PATH}`, async () =>
  profile()
);

export const createAccount = createAsyncThunk(
  `${API_PATH}/create-user`,
  async data => createUser(data)
);

export const createCashFlowSlice = createAsyncThunk(
  `${API_PATH}/create-cash-flow`,
  async data => createCashFlow(data)
);
export const getListCashFlowSlice = createAsyncThunk(
  `${API_PATH}/list-cash-flow`,
  async () => {
    const res = await getListCashFlow();
    return res;
  }
);
export const cancelCashFlowSlice = createAsyncThunk(
  `${API_PATH}/cancel-cash-flow`,
  async data => {
    const res = await cancelCashFlow(data);
    return res;
  }
);

export const deleteAccount = createAsyncThunk(
  `${API_PATH}/delete-user`,
  async id => deleteUser(id)
);

export const changPassword = createAsyncThunk(
  `${API_PATH}/reset-password`,
  async data => resetPassword(data)
);

export const statisticData = createAsyncThunk(
  `${API_PATH}/statistic`,
  async () => getStatistic()
);

export const getActivitiesData = createAsyncThunk(
  `${API_PATH}/activities`,
  async params => getActivities(params)
);

export const listTransInDay = createAsyncThunk(
  `${API_PATH}/dayHistory`,
  async () => getTranToday()
);
export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setList: (state, { payload }) => {
      state.list = payload;
    },
    setProfileUser: (state, { payload }) => {
      state.profile = payload;
    },
    setStatisticData: (state, { payload }) => {
      state.statistic = payload;
    },
    setActivitiesData: (state, { payload }) => {
      state.activities = payload;
    },
    setActivitiesMetaData: (state, { payload }) => {
      state.activitiesMetaData = payload;
    },
    setListTransInDay: (state, { payload }) => {
      state.listTranDayHistory = payload;
    }
  },
  extraReducers: {
    [getListAccount.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        state.list = payload?.data?.data || [];
      }
    },
    [getProfileUser.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        state.profile = payload?.data?.data || {};
      }
    },
    [statisticData.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        state.statistic = payload?.data?.data || {};
      }
    },
    [getActivitiesData.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        state.activities = payload?.data?.data || [];
        state.activitiesMetaData = payload?.data?.metaData || null;
      }
    },
    [listTransInDay.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        state.listTranDayHistory = payload?.data?.data || [];
      }
    },
    [getListCashFlowSlice.fulfilled]: (state, { payload }) => {
      if (payload.status) {
        const { data } = payload.data;
        state.listCashFlow = data;
      }
    }
  }
});

export const { setList } = accountSlice.actions;

export default accountSlice.reducer;
